import React, {useState, useEffect} from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, isVerifyEmail, userToken, logout } from "../../../features/user";
import { isShowUserPopup, setShowUserPopup, showMessage } from "../../../features/common";

import axios from "axios";
import { API_200, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../../Constants';
import {Trans, useTranslation } from 'react-i18next';
import {checkApiSessionErrorMessage, checkValidToken, userLoggedIn, getLang, translateList, arrayBufferToBase64, navigateTo, showLoading } from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';

export function WriterProfile() {
    const [state, setState] = useState({writer:{}});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();

    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);
    const showUserPopup = useSelector(isShowUserPopup);
    

    useEffect(()=>{
        (async () => {
    //dispatch(setShowUserPopup({showUserPopup : true}));
            await checkValidToken(navigate, dispatch, false, true, '/start');
            if(userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)){
                getWriter();
            } 
        })();
        // eslint-disable-next-line
    },[]);

    const getWriter = async () => {
        showLoading(dispatch, true);
        let errorMessage = DEFAULT_ERROR_TEXT;

        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

        try {
            const reply = await axios.get(`${API_URL }/user/`, config);
            showLoading(dispatch, false);
            //console.log(reply);
            if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_200) {
                if(reply.data.avatar && reply.data.avatar.length === 1) {
                    reply.data.avatar = reply.data.avatar[0];
                }
                setState({
                    ...state,
                    writer: reply.data
                });
            }
        } catch (e) {
            showLoading(dispatch, false);
            // console.log(e.response);
            if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                errorMessage = e.response.data["errors"][0];
            }
            // if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
            //     setState({
            //         ...state,
            //         errors: {server_error: errorMessage}
            //     });
            // }
            if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
                dispatch(showMessage({message : errorMessage}));
            }
        }
    }

    const close = () => {
        dispatch(setShowUserPopup({showUserPopup : false}));
    }

    const userPopup =() => {
        return (
            <div className='user-popup'>
                <img className='user-popup-image' src={'/images/edit.png'}  alt=''/>
                <div className='font-30 font-bold mr50 ml50 mt10'>{t('profile_popup_title')}</div>
                <div className='font-13 mr60 ml60 mt10'>{t('profile_popup_text')}</div>
                <div className='popup-button mt10' onClick={()=>{close();navigateTo(dispatch, navigate, '/writer-list-of-tasks')}}>{t('list_of_tasks')}</div>
                <div className='font-13 mr60 ml60 mt10'>{t('profile_popup_text_2')}</div>
                <img className='close-icon' src={'/images/close_x.png'} onClick={()=>close()} alt=''/>
            </div>
        )
    }

    return (
        <Frame showMenu={true} showNav={true}>
            <div className='main main-writer-profile'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                    {state.writer?<Background >
                        <div className='right-main-inner'>
                            <div className='center-div font-15 font-bold mt40' onClick={() => navigate('/edit-writer-profile')}>{t('edit')}</div>
                            <div className='center-div mt5 relative'>
                                <img src={state.writer.avatar?'/images/avatar.png':'/images/photo_upload.png'} className='avatar-border' alt=''/>
                                <div className='avatar-div'>
                                    {state.writer.avatar && <img src={arrayBufferToBase64(state.writer.avatar)} className='avatar' alt=''/>}
                                </div>
                            </div>

                            <div className='text-align-center font-20 font-bold'>{(state.writer.firstName ?? '')+(state.writer.lastName ? (' '+state.writer.lastName) : '')}</div>
                            <div className='text-align-center font-14 font-bold mt5'>{t(state.writer.howDoYouDefineYourself ?? '')}</div>
                            <div className='text-align-center font-20 font-bold mt5'>{state.writer.fewWordsAboutYourself ?? ''}</div>
                            <div className='writer-profile-bottom'></div>
                        </div>
                    </Background>:null}
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
            {showUserPopup && userPopup()}
        </Frame>
    );
}